import AddBoxIcon from '@mui/icons-material/AddBox'
import { Alert, Avatar, Box, Typography } from '@mui/material'
import React from 'react'

import Database from '../../types/Database'

interface CreateDeskHeaderProps {
  user: Database.User | null
  desk: Database.Desk | null
}

/**
 * CreateDeskHeader - Header component for desk creation/editing
 *
 * Displays the avatar, title, and authentication warning.
 */
export default function CreateDeskHeader({
  user,
  desk
}: CreateDeskHeaderProps) {
  const isAuthenticated = user?.uid && user.uid !== ''

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 2
      }}
    >
      {/* User Authentication Warning */}
      {!isAuthenticated && (
        <Alert
          severity='error'
          sx={{
            mb: 2,
            width: '100%',
            borderRadius: 2
          }}
        >
          User authentication required
        </Alert>
      )}

      {/* Title with Icon */}
      {!desk ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Avatar
              sx={{
                bgcolor: 'primary.main',
                width: 32,
                height: 32
              }}
            >
              <AddBoxIcon fontSize='small' />
            </Avatar>
            <Typography
              component='h1'
              variant='h6'
              data-testid='heading'
              sx={{ fontWeight: 600 }}
            >
              Create a Desk
            </Typography>
          </Box>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 2 }}>
            Add a new desk to your office space
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Avatar
              sx={{
                bgcolor: 'primary.main',
                width: 32,
                height: 32
              }}
            >
              <AddBoxIcon fontSize='small' />
            </Avatar>
            <Typography
              component='h1'
              variant='h6'
              sx={{
                fontWeight: 600,
                background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Edit Desk: {desk.name}
            </Typography>
          </Box>
          <Typography variant='body1' color='text.secondary' sx={{ mb: 2 }}>
            Update the details for this desk
          </Typography>
        </>
      )}
    </Box>
  )
}
